import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "trending-modal" */
    /* webpackPreload: true */
    './index.js'
  ),
  LoadingComponent: () => <React.Fragment />,
  serverMode: 'defer'
});
